import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import classnames from 'classnames';

import { isLessThanBreakpoint } from 'dpl/util/grid';
import SmartImage from 'dpl/components/SmartImage';
import {
  ANALYTICS_EVENTS,
  ANALYTICS_VIEW_FEATURES,
  ANALYTICS_VIEWS
} from 'dpl/constants/analytics';
import { sendAnalyticsEvent } from 'dpl/util/analytics';

const IS_LT_MD = isLessThanBreakpoint('md');

function LearningCenterArticleCard({ article }) {
  function handleArticleClick(title) {
    sendAnalyticsEvent(ANALYTICS_EVENTS.BUTTON_CLICKED, {
      view: ANALYTICS_VIEWS.HOME,
      view_feature: ANALYTICS_VIEW_FEATURES.LEARNING_CENTER,
      button_cta: title
    });
  }

  return (
    <a
      href={article.article_url}
      className="LearningCenterArticleCard w-100 h-100 relative"
      onClick={() => handleArticleClick(article.title)}
      target="_blank"
      rel="noopener noreferrer"
    >
      <div className="aspect-ratio aspect-ratio--1x1 relative br12 overflow-hidden z-0 mb6">
        <div
          className={classnames('aspect-ratio--object', {
            'transition grow': !IS_LT_MD
          })}
        >
          <SmartImage
            Tag="div"
            className="w-100 h-100 cover bg-center"
            src={article.image_url}
            loadingClass="bg-light-gray"
            crop
          />
        </div>
      </div>
      <p className="db fw-medium font-16 md:font-18">{article.title}</p>
    </a>
  );
}

LearningCenterArticleCard.propTypes = {
  article: PropTypes.shape({
    title: PropTypes.string,
    image_url: PropTypes.string,
    article_url: PropTypes.string
  }).isRequired
};

export default function LearningCenterArticleCardSection() {
  const { data: learningCenterArticles } = useSelector(
    ({ server }) => server.learningCenterArticles
  );

  return (
    <div className="LearningCenterArticleCardSection w-100">
      <div className="container-xl flex gap-12 md:gap-24 overflow-x-scroll no-scrollbars">
        {learningCenterArticles.map(article => (
          <LearningCenterArticleCard key={article.title} article={article} />
        ))}
      </div>
    </div>
  );
}
